import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import MaterialButton from "../../../components/MaterialButton";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonBadgeFill } from "react-icons/bs";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import request, { gql } from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import URL from "../../Utils/url";
import { fromGlobalId } from "../../../lib/decoded/rawPk";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  addBrandRestService,
  deleteBrandService,
  updateRestBrandService,
} from "../../../lib/appUtliz/BrandService";
import { getBrandDetail } from "../../../lib/graphQL/graphQuery";
import { useLoading } from "../../../context/LodingContext";
import { useSuccess } from "../../../context/SucccessContext";
import { useError } from "../../../context/ErrorContext";


export default function AddBrand() {
  const { currentUser } = useAuth();
  const { id: rawPk } = fromGlobalId(currentUser?.id);

  const navigate = useNavigate();
  const params = useLocation();

  const id = params.search.slice(1);
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    pending: false,
  });
  const [selectedData, setSelectedData] = useState([]);
  const [brandData, setBrandData] = useState({
    // Brand Details
    brandName: "",
    brandIndustry: "",
    brandLogo: "",
    previewURL: "",

    // Brand Type Status
    brandNameStatus: "unchecked",
    brandIndustryStatus: "unchecked",
    brandLogoStatus: "unchecked",
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } =
    useError();

  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  //UseEffect to Fetch Data
  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);

  //Fetch Data By ID
  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getBrandDetail, {
        id: id,
      });
      const v = res.getBrandDetail;
      setSelectedData(v);
      setBrandData({
        brandName: v.brandName,
        brandIndustry: v.brandIndustry,
        brandLogo: v?.brandLogo,
        previewURL: URL + "media/" + v?.brandLogo.replace(" ", "%20"),

        brandNameStatus: "success",
        brandIndustryStatus: "success",
        brandLogoStatus: "success",
      });
    } catch (err) {
      console.err("Couldn't Fetch Data : ",err)
    }
  };

  //Handle Change
  const handleBrandDataChange = (event) => {
    let brandState = { ...brandData };
    const changeAllowed = true;

    switch (event.target.name) {
      case "brandName": {
        const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9\\s@#\\$%\\^&\\*\\(\\)_\\+\\-=\\[\\]\\{\\};:'\"`~,.<>\\/?!\\\\|]{1,25})$");

        if (alphaNLenghthRegex.test(event.target.value?.trim())) {
          brandState[event.target.name + "Status"] = "success";
        } else {
          brandState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "brandIndustry": {
        const alphaNLenghthRegex = new RegExp("^([A-Za-z\\s]{1,25})$");
        if (alphaNLenghthRegex.test(event.target.value?.trim())) {
          brandState[event.target.name + "Status"] = "success";
        } else {
          brandState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "brandlogo": {
        // Handle file upload
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();

          reader.onload = () => {
            brandState["brandLogo"] = file;
            brandState["previewURL"] = reader.result;
            brandState["brandLogoStatus"] = "success";
          };
          reader.readAsDataURL(file);
        } else {
          brandState["brandLogoStatus"] = "unchecked";
        }
        break;
      }
      default:
        break;
    }

    if (changeAllowed) {
      brandState[event.target.name] = event.target.value;
    }

    setBrandData(brandState);
  };

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      brandData.brandNameStatus === "success" &&
      brandData.brandIndustryStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  //Create Function
  const handleAddBrandData = async () => {
    const formData = new FormData();
    formData.append("user", rawPk);
    formData.append("brand_name", brandData.brandName);
    formData.append("brand_industry", brandData.brandIndustry);
    if (brandData.brandLogo) {
      formData.append("brand_logo", brandData.brandLogo);
    }
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });

        setCirleLoading(true);
        const { status, pending, errormessage } = await addBrandRestService(
          formData
        );
        setCirleLoading(pending);
        if (status) {
          setSuccessStatus(true);
          setSucessTitle(" Brand Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/brand");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Update Funciton
  const handleEditBrandData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      messsage: "Are you sure  you want to edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        const formData = new FormData();
        formData.append("user", rawPk);
        formData.append("brand_name", brandData.brandName);
        formData.append("brand_industry", brandData.brandIndustry);
        if (brandData.brandLogo.name) {
          formData.append("brand_logo", brandData.brandLogo);
        }
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const { errormessage, status } = await updateRestBrandService(
          formData,
          id
        );
        setCirleLoading(false);
        if (status) {
          setSuccessStatus(true);
          setSucessTitle("Brand Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/brand");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage);
          setTimeout(() => {
            setErrorStatus(false);
          }, 1000);
        }
      },

      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Delete Function
  const handledeleteBrandData = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to Delete your detail.",
        showCancel: true,
        showConfirm: true,
  
        onConfirm: async () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setCirleLoading(true);
          const delteStatus = await deleteBrandService(id);
          setCirleLoading(false);
          if (delteStatus) {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
            setSuccessStatus(true);
            setSucessTitle(" Brand Deleted");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/brand");
            }, 1000);
          } else {
            setErrorStatus(true);
            setTimeout(() => {
              setErrorStatus(false);
            }, 1000);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };

  //Discard Function
  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

    setBrandData({
      brandName: selectedData.brandName,
      brandIndustry: selectedData.brandIndustry,
      brandLogo: selectedData.brandLogo,

      //Brand status
      brandNameStatus: "success",
      brandIndustryStatus: "success",
      brandLogoStatus: "success",
    });
  };

  //Image Handle Change
  const handleBrandImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setBrandData({
          ...brandData,
          brandLogo: file,
          previewURL: reader.result,
          brandLogoStatus: "success",
        });
      };
      reader.readAsDataURL(file);
    }
  };

  //Cancel Function
  const handleCancelBrandData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        navigate("/brand");
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  return (
    <DashboardLayout>

      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
          pending={confirmationDialog.pending}
        />
      )}

      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Brand details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={handledeleteBrandData}
                      startIcon={<DeleteIcon />}
                    >
                      Delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) 
              :togglePage.edit === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit brand details
                    </MaterialTypography>
                  
                  </Stack>
                  <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                </Stack>
              )
              : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Brand Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "60vh" }}>
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
              <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
              <MaterialTypography
              sx={{color:'#460058',fontFamily:'Aptos'}}
                component="label"
                variant="body2"
                fontWeight="700"
              >
                Brand Information
              </MaterialTypography>
            </Stack>
    
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Brand Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="brandName"
                  placeholder=" eg. Samsung..."
                  size="small"
                  value={brandData.brandName}
                  onChange={handleBrandDataChange}
                  error={brandData.brandNameStatus === "error" ? true : false}
                  success={
                    brandData.brandNameStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {brandData.brandNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Brand name should be maximum 25 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Brand Industry <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="brandIndustry"
                  placeholder=" eg. Samsung..."
                  size='small'
                  value={brandData.brandIndustry}
                  onChange={handleBrandDataChange}
                  error={
                    brandData.brandIndustryStatus === "error" ? true : false
                  }
                  success={
                    brandData.brandIndustryStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {brandData.brandIndustryStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Brand industry should be maximum 25 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Brand Logo
                  </MaterialTypography>
                </MaterialBox>
                {togglePage?.view === true ? null : (
                  <MaterialInput
                    name="brandlogo"
                    type="file"
                    size="small"
                    placeholder=" eg. Samsung..."
                    onChange={handleBrandImageChange}
                    error={brandData.brandLogoStatus === "error" ? true : false}
                    success={
                      brandData.brandLogoStatus === "success" ? true : false
                    }
                    disabled={togglePage?.view === true ? true : false}
                  />
                )}
                {brandData.brandLogoStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Brand image Must be in png, jpg, jpeg..
                    </FormHelperText>
                  </FormControl>
                )}
                {brandData.previewURL && (
                  <MaterialBox mt={2}>
                    <img
                      src={brandData.previewURL}
                      alt="Brand Logo Preview"
                      width="100"
                    />
                  </MaterialBox>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={3}
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleDiscardButton}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  size="small"

                  disabled={!checkAllFields()}
                  onClick={handleEditBrandData}
                >
                  Update
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={handleCancelBrandData}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  size="small"
                  disabled={!checkAllFields()}
                  onClick={handleAddBrandData}
                >
                  Submit
                </MaterialButton>
              </>
            ) : null}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
